import { render } from "./Relation.vue?vue&type=template&id=c4ebd566"
import script from "./Relation.vue?vue&type=script&lang=js"
export * from "./Relation.vue?vue&type=script&lang=js"

import "./Relation.vue?vue&type=style&index=0&id=c4ebd566&lang=less"

import exportComponent from "/builds/fa4daba7/0/develop/front_payments_config/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__